import { Codecs, } from "../types.js";
import { isq } from "../../isq/index.js";
import { BaseCodec } from "./base-codec.js";
export class ScalarCodec extends BaseCodec {
    unit;
    static get = (definition) => {
        return new ScalarCodec(isq.getUnit(definition.unit));
    };
    constructor(unit) {
        super();
        this.unit = unit;
    }
    setUnit(unit) {
        this.unit = unit;
        return this;
    }
    encode(decodedValue) {
        return [decodedValue != null ? this.unit.toBase(decodedValue) : null];
    }
    _decode(encodedValue) {
        return this.unit.fromBase(encodedValue);
    }
    getDefinition() {
        return {
            id: Codecs.SCALAR,
            unit: this.unit.getName(),
        };
    }
    toString() {
        return JSON.stringify(this.getDefinition());
    }
}
